import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store.ts'
import { getCurrentQuarterRange } from '../../utils/time.ts'

interface RankingInputState {
  dateRange: [string | null, string | null]
  region: string
  firm: string
  groupByFirm: boolean
}

export const rankingInputSlice = createSlice({
  name: 'rankingInput',
  initialState: {
    dateRange: getCurrentQuarterRange() as [string, string],
    region: 'All',
    firm: '',
    groupByFirm: false,
  } as RankingInputState,
  reducers: {
    setRankingInputDateRange: (state, action) => {
      state.dateRange = [
        action.payload?.[0] ? action.payload[0] : null,
        action.payload?.[1] ? action.payload[1] : null,
      ]
    },
    setRankingRegion: (state, action) => {
      state.region = action.payload
    },
    setRankingFirm: (state, action) => {
      state.firm = action.payload
    },
    setGroupByFirm: (state, action) => {
      state.groupByFirm = action.payload
    },
  },
})

export const selectRankingInput = (state: RootState) => state.rankingInput

export const {
  setRankingInputDateRange,
  setRankingRegion,
  setRankingFirm,
  setGroupByFirm,
} = rankingInputSlice.actions
